import { SearchEntityTypeEnum } from 'shared/domains/apollo/generated/types';
export const getSearchEntityLink = (type, entityId) => {
    switch (type) {
        case SearchEntityTypeEnum.DocumentComposed:
        case SearchEntityTypeEnum.DocumentFreetext:
        case SearchEntityTypeEnum.DocumentUploaded:
            return `/document/${entityId}`;
        case SearchEntityTypeEnum.Folder:
            return `/files/${entityId}`;
        case SearchEntityTypeEnum.Template:
            return `/contracts?id=${entityId}`;
        case SearchEntityTypeEnum.User:
            return '/users';
        case SearchEntityTypeEnum.Draft:
            return `/draft/${entityId}`;
        default:
            return '';
    }
};
